import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, fromEvent  } from 'rxjs';
import { environment } from '../../environments/environment';
import { MatDialog } from "@angular/material/dialog";

import auth0 from 'auth0-js';
import { ActivatedRoute } from '@angular/router';
import { LoginStateService } from '../pages/login/login-state.service';
import { SnackbarService } from './snackbar.service';
import { takeUntil } from 'rxjs/operators';
import { LogoutDialogComponent } from '../components/logout-dialog/logout-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements OnDestroy  {
  private AUTH_URL: string = environment.baseUrl + environment.authApiUrl;
  private auth0_domain = environment.auth0_domain;
  private auth0_client_id = environment.cliendId;
  user!: string;
  returnUrl: BehaviorSubject<string> = new BehaviorSubject('');
  private loaderSource = new BehaviorSubject<boolean>(false);
  private tokenExpiredSource = new BehaviorSubject<boolean>(false);
  private webAuth = new auth0.WebAuth({
    domain: this.auth0_domain,
    clientID: this.auth0_client_id,
    responseType: 'token id_token',
    scope: 'openid profile email phone'
  });
  isLoggingIn = false;
  isLoadingResults = true;
  loaderVal$ = this.loaderSource.asObservable();
  private isLoggingOut = false; // Add a flag to prevent recursive calls
  private logoutEvent = new BroadcastChannel('logout'); // Use BroadcastChannel
  private ngUnsubscribe = new Subject<void>();
  private hasLoggedOut = false; // To prevent multiple popups
  private loginEvent = new BroadcastChannel('login'); // New BroadcastChannel for login
  private isLoggingInInternal = false; // To avoid infinite loops
  private isLogoutDialogOpen = false; // Flag to prevent stacking multiple logout dialogs
  private readonly LOGGED_IN_KEY = 'isLoggedIn'; // New localStorage key

  constructor(private http: HttpClient, private sbService: SnackbarService, private dialog: MatDialog,
    private router: Router,  private loginStateService: LoginStateService, private ngZone: NgZone) {
      this.listenForLogoutEvents();
      this.listenForStorageEvents(); 
      this.listenForLoginEvents(); // Listen for login events

      window.addEventListener('storage', (event) => {
        this.ngZone.run(() => {
          if (event.storageArea == localStorage && event.key === this.LOGGED_IN_KEY && event.newValue === 'true') {
            this.handleLoginInOtherTab();
          } else if (event.storageArea == localStorage && event.key === 'activeLabel' && event.newValue === null && !this.isLoggingOut && !this.hasLoggedOut) {
            this.handleLogoutInOtherTab();
          }
        });
      }, false);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.logoutEvent.close();
    this.loginEvent.close();
  }

  tokenExpired$ = this.tokenExpiredSource.asObservable();
setReturnUrl(url: string) {
  this.returnUrl.next(url);
}
  getLoaderVal(val: boolean) {
    this.loaderSource.next(val);
  }

  setTokenExpired(expired: boolean) {
    this.tokenExpiredSource.next(expired);
    this.getLoaderVal(expired); // Show/hide loader based on expired state
  }

  public login(): void {

    this.webAuth.popup.authorize({
      redirectUri: `${window.location.origin}`,
      owp: true,
      domain: this.auth0_domain,
      responseType: 'token id_token',
      // connection: 'google-oauth2',
      // prompt: 'select_account'
    }, (err: any, authResult: any) => {
      if (authResult && authResult.accessToken && authResult.id_token) {
        this.webAuth.client.userInfo(authResult.accessToken, (userErr: any, userInfo: any) => {
          if (userInfo) {
            // console.log("userInfo",userInfo, authResult)
            authResult = {
              ...authResult,
              ...userInfo
            };
            // console.log(authResult.id_token)
            this.loginStateService.getUserInfo(authResult);
            this.isLoggingIn = false;
            localStorage.setItem(this.LOGGED_IN_KEY, 'true');
            this.loginEvent.postMessage('loggedIn'); // Notify other tabs about login
                        const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authResult.id_token}`
              })
            };
            this.http.post(this.AUTH_URL, { "email": authResult.email }, httpOptions).subscribe(response => {
              // const data = response["data"];
              // console.log(response)
              const data = (response as any)["data"];
              // console.log(data)
              this.loginStateService.getLoginData(data);
              this.isLoggingIn = false;
              // localStorage.setItem('activeLabel'); // Set a flag in localStorage
              this.loginEvent.postMessage('loggedIn'); // Notify other tabs about login
            },
              (err: any) => {
                // console.log(err);
                this.sbService.openDefault(err);
                this.isLoggingIn = true;
                this.getLoaderVal(this.isLoggingIn);
              })
          } else if (err) {
            this.isLoggingIn = true;
          }
        });
      } else if (err) {
        this.sbService.openDefault(err.original.error_description || err.original);
        this.isLoadingResults = true;
      }
    });

  }

  // logout() {
  //   if (this.isLoggingOut) {
  //     return; // Prevent multiple calls during logout
  //   }
  //   this.isLoggingOut = true;
  //   this.isLoggingIn = false;
  //   sessionStorage.removeItem('currentUser');
  //   localStorage.removeItem('currentUser');
  //   sessionStorage.removeItem('activeLabel');
  //   localStorage.removeItem('activeLabel');
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   this.router.navigate(['/']).then(() => {
  //     window.location.reload(); // Reload after navigation is complete
  //     this.isLoggingOut = false; // Reset the flag after logout is done
  //   });
  // }

  logout() {
    if (this.isLoggingOut) {
      return; // Prevent multiple calls during logout
    }
    this.isLoggingOut = true;
    this.hasLoggedOut = true; // Mark that this tab initiated the logout
    this.logoutEvent.postMessage('logout'); // Notify other tabs
    this.logoutInternal();
  }


  public logoutInternal() {
    this.isLoggingOut = true; // Prevent further logout event triggers
    this.isLoggingIn = false;
    this.dialog.closeAll(); // Ensure any open dialogs are closed
    sessionStorage.removeItem('currentUser');
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('activeLabel');
    localStorage.removeItem('activeLabel');
    localStorage.removeItem(this.LOGGED_IN_KEY); // Remove login status
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/']).then(() => {
      window.location.reload(); // Reload after navigation is complete
      this.isLoggingOut = false; // Reset the flag after logout is done
      this.hasLoggedOut = false; // Reset the flag
    }).catch(() => {
      // If navigation fails (e.g. due to an AuthGuard), force a reload anyway
      window.location.reload();
    });
  }
  
  private listenForLoginEvents() {
    fromEvent<MessageEvent>(this.loginEvent, 'message')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event: MessageEvent) => {
        if (event.data === 'loggedIn' && this.router.url.includes('/login') && !this.isLoggingInInternal) {
          this.ngZone.run(() => {
            this.handleLoginInOtherTab();
          });
        }
      });
  }

  private handleLoginInOtherTab() {
    this.isLoggingInInternal = true;
    this.router.navigate(['/']).then(() => {
      this.isLoggingInInternal = false;
      window.location.reload(); 
    });
  }

  private listenForLogoutEvents() {
    fromEvent<MessageEvent>(this.logoutEvent, 'message')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event: MessageEvent) => {
        if (event.data === 'logout' && !this.isLoggingOut && !this.hasLoggedOut) {
          this.ngZone.run(() => {
            this.handleLogoutInOtherTab();
          });
        }
      });
  }
  private listenForStorageEvents() {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event: StorageEvent) => {
        if (event.key === 'activeLabel' && event.newValue === null && !this.isLoggingOut && !this.hasLoggedOut) {
          this.ngZone.run(() => {
            this.handleLogoutInOtherTab();
          });
        }
      });
  }


  private handleLogoutInOtherTab() {
    if (this.isLogoutDialogOpen) {
      return;
    }
    this.isLogoutDialogOpen = true;

    const dialogRef = this.dialog.open(LogoutDialogComponent, {
      width: '400px',
      disableClose: true
    });

    // Subscribe to dialog close event
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) { // User clicked OK
        // Do NOT reset isLogoutDialogOpen here to prevent race conditions opening a new dialog
        this.logoutInternal(); // Now call logoutInternal here
      } else {
        this.isLogoutDialogOpen = false;
        // console.log("error")
      }
    });
  }
  isLoggedIn(): boolean {
    return localStorage.getItem(this.LOGGED_IN_KEY) === 'true';
  }
}
